import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';

const AppointmentConfirmationInstructions = (_param)=>{
    var { isPhone , confirmationContent , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "isPhone",
        "confirmationContent",
        "className"
    ]);
    var ref, ref1;
    if (!confirmationContent) {
        return null;
    }
    const image = isPhone ? (ref = confirmationContent.image) === null || ref === void 0 ? void 0 : ref.mobile : (ref1 = confirmationContent.image) === null || ref1 === void 0 ? void 0 : ref1.original;
    var _description;
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('appointment-confirmation-instructions', className)
    }), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        className: classnames('appointment-confirmation-instructions__section-heading', className)
    }, confirmationContent.title), confirmationContent.image && /*#__PURE__*/ React.createElement("img", {
        className: classnames('appointment-confirmation-instructions__image', className),
        src: image === null || image === void 0 ? void 0 : image.url,
        alt: (_description = confirmationContent.image.description) !== null && _description !== void 0 ? _description : undefined,
        width: image === null || image === void 0 ? void 0 : image.width,
        height: image === null || image === void 0 ? void 0 : image.height
    }), /*#__PURE__*/ React.createElement("div", {
        className: classnames('appointment-confirmation-instructions__description', className),
        dangerouslySetInnerHTML: {
            __html: confirmationContent.description.value
        }
    }));
};
var AppointmentConfirmationInstructions$1 = AppointmentConfirmationInstructions;

export { AppointmentConfirmationInstructions$1 as default };
//# sourceMappingURL=AppointmentConfirmationInstructions.js.map
